import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const KsefUpdate1207 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення KSEF 12.07</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Повністю перероблена робота з KSeF (Krajowy System e-Faktur): швидше завантаження фактур за тиждень,
        автоматична перевірка, чи фактура вже є на сайті, автопошук водія за номером авта чи KSeF ID, кнопка
        створення фактури одним кліком і токен, який більше не потрібно вводити вручну.
      </p>

      <Alert variant="info">
        <b>Коротко:</b> на сторінці «KSeF — фактури» тепер обирається тиждень (як у звітах), а не дати вручну.
        Після завантаження система сама показує, чи фактура вже є на сайті, і чи належить вона якомусь водію
        (за номером авта або за KSeF ID у профілі водія). Якщо збіг знайдено — фактуру можна створити або
        прив'язати одним кліком.
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        {/* 1. Що змінилось */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Що змінилось</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <b>Швидше завантаження фактур.</b> Замість повільного отримання фактур по одній, тепер
                система дістає їх одразу пачкою за обраний тиждень.
              </li>
              <li>
                <b>Вибір тижня замість ручних дат.</b> На сторінці «KSeF — фактури» тепер стандартний{" "}
                <b>вибір тижня</b> (як у звітах і додаткових коштах) — фактури дістаються за дату виставлення
                в межах понеділка–неділі обраного тижня.
              </li>
              <li>
                Фактури дістаються по всіх ролях компанії одразу (продавець, покупець, уповноважена сторона).
                Якщо якась із ролей тимчасово недоступна — це не заважає отримати решту фактур, просто
                з'явиться попередження над таблицею.
              </li>
              <li>
                <b>Автоматична перевірка, чи фактура вже є на сайті.</b> Кожна фактура з KSeF звіряється з
                базою даних сайту:{" "}
                <Badge bg="success" className="ms-1">Вже є</Badge> — таку фактуру вже додано на сайт;{" "}
                <Badge bg="warning" text="dark" className="ms-1">Схожа сума ×N</Badge> — є фактура водія з
                такою ж сумою, але ще не позначена як фактура з KSeF (можна прив'язати вручну);{" "}
                <Badge bg="light" text="dark" className="ms-1">Немає</Badge> — на сайті такої фактури ще немає.
              </li>
              <li>
                <b>Автоматичний пошук водія.</b> Для кожної фактури система шукає, якому водію вона належить:
                за <b>номером авта</b> (звіряється зі списком авто в розділі «Автопарк», з урахуванням історії
                зміни водія на конкретному авті) та за <b>KSeF ID</b> — окремим ідентифікатором у профілі
                водія (детальніше — пункт 5).
              </li>
              <li>
                <b>Створення й прив'язка фактури одним кліком.</b> Якщо знайдено водія — з'являється кнопка
                «Створити фактуру» (сума брутто й ПДВ підтягуються з KSeF автоматично, фактура одразу отримує
                статус «Підтверджено»). Якщо знайдено схожу за сумою фактуру, яку хтось уже завантажив на сайт
                раніше — з'являється кнопка «Прив'язати» замість створення дубліката.
              </li>
              <li>
                <b>Перегляд повної інформації про фактуру.</b> Кнопка «Переглянути фактуру» відкриває картку
                з усіма деталями: продавець, покупець, суми, знайдені збіги з водіями та додаткові текстові
                примітки з самої фактури.
              </li>
              <li>
                <b>Лічильник і таймер запитів.</b> На сторінці тепер видно, скільки разів фактури
                завантажувались за останню годину і скільки часу минуло з останнього завантаження — це
                допомагає не робити запити занадто часто.
              </li>
              <li>
                <b>Токен KSeF більше не вводиться в адмінці.</b> Раніше при кожному відкритті сторінки
                потрібно було вручну отримувати і вставляти код доступу. Тепер це налаштовується один раз
                (пункт 3) і надалі оновлюється автоматично.
              </li>
              <li>
                Сторінка показує, з яким середовищем KSeF зараз працює сайт (робоче/тестове) і чи налаштований
                доступ («Токен налаштовано» / «Токен не налаштовано»).
              </li>
              <li>
                <b>Видалення фактур водіїв.</b> У розділі «Фактури водіїв» тепер можна видалити будь-яку
                фактуру — кнопкою прямо в списку або з картки перегляду фактури.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        {/* 2. Як було раніше */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як було раніше</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Фактури дістававались по одній, що займало значно більше часу при великій кількості фактур.</li>
              <li>Період вибирався вручну двома полями «дата з» / «дата по», без прив'язки до робочих тижнів.</li>
              <li>
                Не було жодної перевірки, чи фактура з KSeF вже завантажена на сайт — легко було створити
                дублікат.
              </li>
              <li>Не було автоматичного зв'язку фактури KSeF з конкретним водієм — усе робилося вручну.</li>
              <li>Код доступу до KSeF потрібно було отримувати вручну й щоразу вставляти в поле на сторінці.</li>
              <li>Видалити фактуру водія зі списку було неможливо.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        {/* 3. Налаштування доступу до KSeF */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Як налаштувати доступ до KSeF (робиться один раз)</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Увійти на сайт <b>ksef.mf.gov.pl</b> як власник фірми (кваліфікований підпис, e-Dowód або
                bankID).
              </li>
              <li>
                У розділі керування токенами створити новий токен доступу з правом читання фактур.
              </li>
              <li>
                Сайт покаже код токена <b>лише один раз</b> — його потрібно повністю скопіювати одразу.
              </li>
              <li>
                Передати цей код розробнику/технічному спеціалісту, який обслуговує сайт, — його потрібно
                один раз внести в налаштування сервера. Самостійно вводити код на сторінці KSeF в адмінці не
                потрібно.
              </li>
              <li>
                Після налаштування відкрити «KSeF — фактури» — має з'явитися зелений напис{" "}
                <Badge bg="success">Токен налаштовано</Badge>. Якщо напис червоний{" "}
                <Badge bg="danger">Токен не налаштовано</Badge> — звернутись до технічного спеціаліста.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        {/* 4. Інструкція — робота зі сторінкою */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Інструкція — як діставати й обробляти фактури KSeF</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Перейти в розділ <b>«Рахунки» → «KSeF — фактури»</b>.</li>
              <li>Переконатись, що зверху зелений напис «Токен налаштовано» (якщо ні — див. пункт 3).</li>
              <li>Обрати потрібний тиждень у полі «Тиждень» — під ним одразу покажуться дати понеділка й неділі.</li>
              <li>
                Натиснути <b>«Завантажити фактури»</b>. Запит може тривати від кількох секунд до 1–2 хвилин —
                закривати сторінку в цей час не потрібно.
              </li>
              <li>
                У таблиці результатів для кожної фактури видно: дату, номер, контрагента, суми, колонку{" "}
                <b>«На сайті»</b> (чи вже є така фактура) та колонку <b>«Водій / авто»</b> (знайдені збіги).
              </li>
              <li>
                Якщо в колонці «На сайті» — <Badge bg="success">Вже є</Badge>, жодних додаткових дій не
                потрібно, фактура вже пов'язана.
              </li>
              <li>
                Якщо <Badge bg="warning" text="dark">Схожа сума ×N</Badge> — під рядком фактури з'явиться
                список схожих фактур на сайті з кнопкою <b>«Прив'язати»</b>. Це варто зробити, якщо це справді
                та ж сама фактура (наприклад, водій уже завантажив фото раніше) — щоб не створювати дублікат.
              </li>
              <li>
                Якщо в колонці «Водій / авто» показано ім'я водія — можна натиснути{" "}
                <b>«Створити фактуру»</b>. Якщо збігів декілька — спочатку обрати потрібного водія у списку,
                що з'явиться над кнопкою.
              </li>
              <li>
                Кнопка <b>«Переглянути фактуру»</b> відкриває детальну картку з усією інформацією про фактуру.
              </li>
              <li>
                Над таблицею результатів видно, скільки разів фактури завантажувались за останню годину і
                скільки часу минуло з останнього завантаження.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        {/* 5. Як прив'язати водія до KSeF за KSeF ID */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Як прив'язати водія до KSeF за KSeF ID (якщо не спрацював пошук за номером авта)</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Перейти в розділ «Користувачі», відкрити картку потрібного водія на редагування.</li>
              <li>У блоці <b>«Ідентифікатори водія»</b> натиснути «+» (додати).</li>
              <li>
                У полі «Назва» вписати рівно <code>ksefId</code>, у полі «Номер» — значення, за яким фактуру
                можна впізнати (наприклад, внутрішній ідентифікатор водія, який фігурує в даних фактури).
              </li>
              <li>Зберегти. З наступного завантаження фактур KSeF система враховуватиме цей ідентифікатор при пошуку.</li>
            </ol>
            <Alert variant="secondary" className="mb-0">
              Пошук за номером авта працює автоматично й нічого додатково налаштовувати не потрібно — головне,
              щоб авто й водій були правильно пов'язані в розділі «Автопарк».
            </Alert>
          </Accordion.Body>
        </Accordion.Item>

        {/* 6. Результат */}
        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Який буде результат</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Фактури дістаються швидше й одразу за весь тиждень, а не частинами по кожній окремо.</li>
              <li>Адміністратору не потрібно щоразу вручну отримувати й вставляти код доступу до KSeF.</li>
              <li>Вибір тижня замість ручних дат — зручніше й узгоджено з іншими звітами в системі.</li>
              <li>Видно одразу, які фактури з KSeF уже є на сайті, а які ще ні — менше ризику пропустити або задвоїти фактуру.</li>
              <li>Фактури автоматично пропонується прив'язати до конкретного водія — менше ручної роботи.</li>
              <li>Будь-яку фактуру водія, включно з фактурами з KSeF, тепер можна видалити зі списку за потреби.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default KsefUpdate1207;
